export interface KriteriaAuditLimbah {
  no: number;
  kriteria: string;
  dasar_regulasi: string;
}

export const KRITERIA_AUDIT_LIMBAH: KriteriaAuditLimbah[] = [
  {
    no: 1,
    kriteria: "Membuang limbah padat non infeksius ke kantong hitam",
    dasar_regulasi: "Permenkes 7/2019 Bab III; Kepmenkes 1204/2004"
  },
  {
    no: 2,
    kriteria: "Membuang limbah padat infeksius ke kantong kuning",
    dasar_regulasi: "Permenkes 27/2017 Ps.11; Permenkes 7/2019"
  },
  {
    no: 3,
    kriteria: "Membuang limbah cair ke saluran limbah",
    dasar_regulasi: "Permenkes 7/2019; PP 22/2021 (Limbah B3)"
  },
  {
    no: 4,
    kriteria:
      "Membuang limbah benda tajam ke kontainer tahan air dan tahan tusuk",
    dasar_regulasi: "Permenkes 27/2017 Lamp.; Kepmenkes 1204/2004"
  }
];

export const METODE_AUDIT_OPTIONS = [
  { text: "Observasi Langsung", value: "observasi_langsung" },
  { text: "Wawancara", value: "wawancara" },
  { text: "Telusur Dokumen", value: "telusur_dokumen" }
];

export const PENILAIAN_OPTIONS = [
  { text: "Ya", value: "ya", color: "success", icon: "mdi-check-bold" },
  { text: "Tidak", value: "tidak", color: "error", icon: "mdi-close-thick" },
  { text: "N/A", value: "na", color: "grey", icon: "mdi-minus" }
];
